export default __webpack_public_path__ + "static/media/36t.c081cd88.jpg";